import { render, staticRenderFns } from "./LoanDashboard.vue?vue&type=template&id=4fb227aa"
import script from "./LoanDashboard.vue?vue&type=script&lang=js"
export * from "./LoanDashboard.vue?vue&type=script&lang=js"
import style0 from "./LoanDashboard.vue?vue&type=style&index=0&id=4fb227aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports